"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Mail, Phone, MapPin, Clock, ChevronRight } from "lucide-react";
export default function ContactInformation() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const contactDetails = [{
    icon: Phone,
    label: "Phone",
    value: "323-492-6292",
    href: "tel:323-492-6292"
  }, {
    icon: Mail,
    label: "Email",
    value: "phoenixenerprises@gmail.com",
    href: "mailto:phoenixenerprises@gmail.com"
  }, {
    icon: MapPin,
    label: "Location",
    value: "Los Angeles, CA, USA",
    href: null
  }, {
    icon: Clock,
    label: "Availability",
    value: "24/7 VIP Concierge",
    href: null
  }];
  return <section id="contact-information" className="relative min-h-screen overflow-hidden bg-[#1A1A1A] text-white py-28">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/luxury_sedan_la_night.png)] opacity-40" aria-hidden="true" />
      <div className="absolute inset-0 bg-linear-to-b from-[#1A1A1A]/80 via-transparent to-[#1A1A1A]/80" />

      <div className="relative z-10 grid grid-cols-1 lg:grid-cols-5 min-h-screen">
        {}
        <div ref={leftRef} className={`lg:col-span-3 flex items-center justify-center p-6 md:p-12 lg:p-20 transition-all duration-500 ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div className="glass-effect w-full max-w-xl p-8 md:p-12 border-[#C5A059]/30 bg-[#1A1A1A]/60 backdrop-blur-md rounded-lg shadow-strong">
            <div className="mb-10">
              <h1 className="font-[family:var(--font-heading)] text-4xl md:text-5xl font-bold mb-4 text-white tracking-tight">
                Elite <span className="text-[#C5A059]">Concierge</span>
              </h1>
              <p className="text-[#A1A1A1] text-lg font-sans max-w-md">
                Experience the pinnacle of professional mobility in Los Angeles. Our team is available 24/7 for your luxury transportation needs.
              </p>
            </div>

            <div className="space-y-6">
              {contactDetails.map((detail, i) => {
              const Icon = detail.icon;
              return <div key={i} data-index={i} className="group flex items-center gap-6 p-4 rounded-md transition-all duration-200 hover:bg-white/5 border border-transparent hover:border-[#C5A059]/20">
                    <div className="flex-shrink-0 w-14 h-14 rounded-md bg-[#C5A059]/10 flex items-center justify-center border border-[#C5A059]/30 group-hover:bg-[#C5A059] transition-colors duration-300">
                      <Icon className="w-6 h-6 text-[#C5A059] group-hover:text-[#1A1A1A]" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-xs font-bold text-[#C5A059] uppercase tracking-[0.2em] mb-1">
                        {detail.label}
                      </p>
                      {detail.href ? <Link to={detail.href} className="text-xl font-display font-semibold text-white hover:text-[#C5A059] transition-colors block">
                          {detail.value}
                        </Link> : <p className="text-xl font-display font-semibold text-white">{detail.value}</p>}
                    </div>
                    {detail.href && <ChevronRight className="w-5 h-5 text-[#A1A1A1] group-hover:text-[#C5A059] transition-colors" />}
                  </div>;
            })}
            </div>

            <div className="mt-12 pt-8 border-t border-white/10">
              <Button className="btn-primary w-full h-14 text-lg bg-[#C5A059]" onClick={() => window.location.href = "tel:323-492-6292"}>
                <Phone className="w-5 h-5 mr-2" />
                Instant Reservation
              </Button>
            </div>
          </div>
        </div>

        {}
        <div ref={rightRef} className={`lg:col-span-2 flex items-center justify-center p-6 md:p-12 lg:p-20 transition-all duration-700 delay-200 ${rightVisible ? "opacity-100 scale-100" : "opacity-0 scale-105"}`}>
          <div className="glass-effect w-full h-full min-h-[500px] overflow-hidden rounded-lg border-[#C5A059]/30 shadow-strong relative group">
            <div className="absolute inset-0 bg-[#C5A059]/5 pointer-events-none z-10 group-hover:opacity-0 transition-opacity duration-500" />
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d423286.27404345275!2d-118.69192993701652!3d34.02016130653294!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c75ddc27da13%3A0xe22fdf6f254608f4!2sLos%20Angeles%2C%20CA%2C%20USA!5e0!3m2!1sen!2s!4v1234567890123!5m2!1sen!2s" width="100%" height="100%" style={{
            border: 0,
            filter: "invert(90%) hue-rotate(180deg) contrast(1.2) brightness(0.8)"
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Los Angeles Service Area" className="w-full h-full grayscale-[0.5]" />
            <div className="absolute bottom-6 left-6 right-6 z-20">
              <div className="bg-[#1A1A1A]/90 backdrop-blur-md p-4 rounded-md border border-[#C5A059]/30">
                <p className="text-[#C5A059] text-xs font-bold uppercase tracking-widest mb-1">Service Area</p>
                <p className="text-white font-display font-semibold">Greater Los Angeles & Southern California</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}